import axios from 'axios';

export const fetchEmergencyStatus = async () => {
  try {
    const res = await axios.get('/api/emergency-mode');
    return res.data?.status || 'normal';
  } catch (err) {
    console.error('Error checking emergency status:', err);
    return 'normal';
  }
};

export const isFeatureLocked = (status, blockedModes = []) => {
  return blockedModes.includes(status);
};
